module.exports = __webpack_public_path__ + "img/keymilestone-banner.d07b0406.png";